import { OcrLabIdVerificationRequest } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const postOcrLabIdVerification = (
  constructPost: ConstructPost,
  data: OcrLabIdVerificationRequest,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/ocr-lab-request/send-id-verification-email`,
    { data },
    { preventDefaultErrorToast: true },
  );
